import { createMuiTheme } from '@material-ui/core/styles';
import teal from '@material-ui/core/colors/teal';

const black = 'rgba(0, 0, 0, 0.65)';
const white = 'rgba(256, 256, 256, 0.9)';

// theme initial
const theme = createMuiTheme({
  palette: {
    primary: {
      main: teal[300],
      contrastText: white
    },
    text: {
      primary: black,
    },
  },
  typography: {
    fontFamily:
      'source-han-sans-traditional, ' +
      'Roboto, "Segoe UI", "Helvetica Neue", Arial, sans-serif',
    button: {
      color: black
    }
  },
  contentWidth: {
    main: 800,
    sub: 500
  },
  overrides: {
    MuiButton: {
      contained: {
        color: black
      },
    },
  },
});

export default theme;


// WEBPACK FOOTER //
// ./src/utility/theme.js